export default "__VITE_ASSET__BbqerE7$__"